<template>
  <div id="Page2" class="home">
    <div class="banner">
      <img src="@/assets/img/PG2-1-952x410.png" alt="" />
    </div>
    <div class="bannerBtmLine">
      <div class="leftLine"></div>
      <div class="rightLine"></div>
    </div>
    <div class="mainTop">
      <span class="Breadcrumb">
        <router-link to="/">{{ $t("Homepage") }}</router-link> >
        {{ $t("Travel") }}</span
      >
      <div class="topLine"></div>
    </div>
    <div class="main">
      <div class="Introduction">
        <div class="content">
          <h2>{{ $t("PG2T") }}</h2>
          <span>―</span>
          <p v-for="i in 3" :key="i" :class="{ first: i === 1 }">
            {{ $t(`PG2P${i}`) }}
          </p>
        </div>
      </div>
      <div class="photo">
        <img src="@/assets/img/PG2-2-258x195.png" alt="" />
        <img src="@/assets/img/PG2-3-258x195.png" alt="" />
        <img src="@/assets/img/PG2-4-258x195.png" alt="" />
        <img src="@/assets/img/PG2-5-258x195.png" alt="" />
        <img src="@/assets/img/PG2-6-258x195.png" alt="" />
        <img src="@/assets/img/PG2-7-258x195.png" alt="" />
      </div>
      <div class="midLine"></div>
      <div class="container">
        <div class="card">
          <div class="cardImg">
            <img src="@/assets/img/PG2-8-475x323.png" alt="" />
          </div>
          <div class="cardContent">
            <div class="empty"></div>
            <div class="cardTitle">{{ $t("HICT") }}</div>
            <router-link to="/Introduction/2_1" class="cardBtn">{{
              $t("MCBtn")
            }}</router-link>
          </div>
        </div>
        <div class="card">
          <div class="cardImg">
            <img src="@/assets/img/PG2-9-475x323.png" alt="" />
          </div>
          <div class="cardContent">
            <div class="empty"></div>
            <div class="cardTitle">{{ $t("HICT") }}</div>
            <router-link to="/Introduction/2_2" class="cardBtn">{{
              $t("MCBtn")
            }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page2",
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;

  .main {
    .Introduction {
      display: flex;
      justify-content: flex-end;
      padding: 48px;
      .content {
        color: #d7af21;
        width: 80%;
        padding: 0 16px;
        h2 {
          font-size: 28px;
        }
        span {
          display: block;
          font-size: 26px;
          padding-bottom: 16px;
        }
        .first:first-letter {
          font-size: 26px;
          text-transform: uppercase;
        }
        p {
          font-size: 18px;
          line-height: 24px;
          padding-bottom: 16px;
          letter-spacing: 1px;
        }
      }
    }
    .photo {
      padding: 32px 64px;
      display: grid;
      grid-template-columns: repeat(3, auto);
      grid-template-rows: repeat(2, auto);
      img {
        box-sizing: border-box;
        padding: 8px;
      }
    }
    .midLine {
      height: 16px;
      background-color: #fabf00;
      margin-bottom: 32px;
    }
    .container {
      background-color: #f6f6f6;
      padding: 16px;
      .card {
        // box-sizing: border-box;
        background-color: white;
        margin: 0 16px 32px;
        display: flex;
        border: 1px solid black;
        box-shadow: 1px 1px 7px black;
        .cardImg {
          display: flex;
          flex: 1;
        }
        .cardContent {
          box-sizing: border-box;
          padding: 32px;
          width: 50%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          .cardTitle {
            color: #d7af21;
            font-size: 28px;
            padding: 32px;
          }
          .cardBtn {
            font-size: 22px;

            background-color: #675d39;
            color: #fff8f8;
            padding: 16px 32px;
          }
        }
      }
    }
  }
}
</style>
